// API Configuration
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api/v1';

export const API_ENDPOINTS = {
  // Auth
  AUTH: {
    REGISTER: '/auth/register',
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
    GOOGLE: '/auth/google',
    PASSWORD_RESET_REQUEST: '/auth/password-reset/request',
    PASSWORD_RESET: '/auth/password-reset/reset',
    CHANGE_PASSWORD: '/auth/change-password',
    OTP_REQUEST: '/auth/otp/request',
    OTP_VERIFY: '/auth/otp/verify',
    ACCOUNT_DELETION_REQUEST: '/auth/account-deletion/request',
    ACCOUNT_DELETION_CONFIRM: '/auth/account-deletion/confirm',
  },
  // Users
  USERS: {
    ME: '/users/me',
    UPDATE_PROFILE: '/users/me',
    UPLOAD_AVATAR: '/users/me/avatar',
    DELETE_ME: '/users/me',
  },
  // Health Questionnaire
  HEALTH_QUESTIONNAIRE: {
    ME: '/health-questionnaire/me',
    CREATE: '/health-questionnaire',
    COMPLETED: '/health-questionnaire/completed',
  },
  // Indian Food
  INDIAN_FOOD: {
    SEARCH: '/indian-food',
    CATEGORIES: '/indian-food/categories',
    BARCODE: (code: string) => `/indian-food/barcode/${code}`,
  },
  // Activities
  ACTIVITIES: {
    LIST: '/activities',
    CREATE: '/activities',
    ONE: (id: string) => `/activities/${id}`,
  },
  // Instagram Reels
  INSTAGRAM_REELS: '/instagram-reels',
  // Health Data
  HEALTH: {
    GOALS: '/health/goals',
    SUGAR_READINGS: '/health/sugar-readings',
    CALORIE_ENTRIES: '/health/calorie-entries',
    STEP_ENTRIES: '/health/steps',
    WEIGHT_ENTRIES: '/health/weight-entries',
    BLOOD_PRESSURE_ENTRIES: '/health/blood-pressure-entries',
    MEDICATIONS: '/health/medications',
    INSULIN: '/health/insulin',
    ANALYTICS: '/health/analytics',
    EXPORT: '/health/export',
  },
  // AI Assistant
  AI: {
    CHAT: '/ai/chat',
    HISTORY: '/ai/conversations',
    ANALYZE_FOOD_IMAGE: '/ai/analyze-food-image',
  },
  // Community
  COMMUNITY: {
    CHALLENGES: '/community/challenges',
    CHALLENGE_JOIN: (id: string) => `/community/challenges/${id}/join`,
    CHALLENGE_PROGRESS: (id: string) => `/community/challenges/${id}/progress`,
    LEADERBOARD: '/community/leaderboard',
    ACHIEVEMENTS: '/community/achievements',
    DAILY_TIPS: '/community/daily-tips',
  },
  // TeleHealth
  TELEHEALTH: {
    DOCTORS: '/telehealth/doctors',
    DOCTOR: (id: string) => `/telehealth/doctors/${id}`,
    APPOINTMENTS: '/telehealth/appointments',
    APPOINTMENT: (id: string) => `/telehealth/appointments/${id}`,
    CANCEL_APPOINTMENT: (id: string) => `/telehealth/appointments/${id}/cancel`,
    AVAILABILITY: (id: string) => `/telehealth/doctors/${id}/availability`,
  },
  // Subscriptions
  SUBSCRIPTIONS: {
    PACKAGES: '/subscriptions/packages',
    SUBSCRIBE: '/subscriptions/subscribe',
    CHANGE_PACKAGE: '/subscriptions/change-package',
    ACTIVATE_TRIAL: '/subscriptions/activate-trial',
    CURRENT: '/subscriptions/me',
    CANCEL: '/subscriptions/me',
    PAYMENT: '/subscriptions/payment',
  },
  // Config (public, no auth)
  CONFIG: {
    FEATURE_FLAGS: '/config/feature-flags',
  },
  // Admin
  ADMIN: {
    USERS: '/admin/users',
    ADMIN_USERS: '/admin/admin-users',
    USER: (id: string) => `/admin/users/${id}`,
    USER_NOTES: (id: string) => `/admin/users/${id}/notes`,
    USER_COMMUNICATIONS: (id: string) => `/admin/users/${id}/communications`,
    ESCALATIONS: '/admin/escalations',
    ESCALATION: (id: string) => `/admin/escalations/${id}`,
    ANALYTICS: '/admin/analytics',
    STATS: '/admin/stats',
    AUDIT_LOGS: '/admin/audit-logs',
    FEATURE_FLAGS: '/admin/feature-flags',
    USER_RESET_PASSWORD: (id: string) => `/admin/users/${id}/reset-password`,
    INTEGRATIONS_VALIDATE: '/admin/integrations/validate',
    INSTAGRAM_REELS: '/admin/instagram-reels',
    INSTAGRAM_REEL: (id: string) => `/admin/instagram-reels/${id}`,
    SUBSCRIPTIONS: '/admin/subscriptions',
    SUBSCRIPTION: (id: string) => `/admin/subscriptions/${id}`,
  },
} as const;

